module.exports = __webpack_public_path__ + "img/24.7dccc997.jpg";